import { render, staticRenderFns } from "./IconSvgOgg.vue?vue&type=template&id=73c9cf27&scoped=true&"
import script from "./IconSvgOgg.vue?vue&type=script&lang=js&"
export * from "./IconSvgOgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c9cf27",
  null
  
)

export default component.exports